import React, {FC, useContext} from "react"
import {IconTypes} from "@irati/ui/src/Icon"
import {Deal} from "@irati/types"
import ShareIconButton from "@irati/ui/src/ShareIconButton"
import DrawerContext from "@irati/ui/src/AppContainer/Context/DrawerContext"
import {getDealUrl} from "../../helpers/getDealUrl"

interface Props {
  deal: Deal
}

const HAS_USER_CLICKED_SHARE_ANIMATION = "has_user_clicked_share_animation"

const SharePerk: FC<Props> = ({deal}) => {
  const {setDrawerOpen} = useContext(DrawerContext)

  const source = "perks_info"
  const type = "perks_info_page"
  const title = "Perkbox deal"
  const url = getDealUrl(deal.urlSlug)
  const sharingData = {title, url, source, type, id: deal.uuid}

  const onClick = (event: any) => {
    event.preventDefault()
    event.stopPropagation()
    localStorage.setItem(HAS_USER_CLICKED_SHARE_ANIMATION, "{}")
    const drawerData = {
      url,
      title,
      alertText: "perks.deals.shareText",
      source,
      type,
      entity_id: deal.uuid
    }
    setDrawerOpen(drawerData)
  }

  return (
    <ShareIconButton
      icon={!localStorage.getItem(HAS_USER_CLICKED_SHARE_ANIMATION) ? IconTypes.shareAnimated : IconTypes.share}
      size={24}
      onClick={onClick}
      copyText={url}
      sharingData={sharingData}
    />
  )
}

export default SharePerk
